import React, { useEffect, useState } from "react";
import trans from "../../../../../utils";
import { useNavigate } from "react-router-dom";

export default function SetupHeader({
	type,
	typeId,
	page,
	setPage,
	setTypeId,
	buildingId,
	projectId,
	setUniqueId,
	setSelect,
	setSelected,
	back,
	setBack,
	setPoiAttachments,
	addPOI,
}) {
	console.log("Page", page);
	console.log("Project Id", projectId, "Building Id", buildingId);

	const handleBackClick = () => {
		setBack(true);
		setPage((p) => Number(p) - 1);
		setUniqueId(null);
		setSelect(false);
		setSelected({
			type: null,
			index: null,
			polyid: null,
		});
	};

	useEffect(() => {
		if (!back) return; // 🔒 only run when back is true

		if (page === 3 && buildingId) {
			setTypeId(buildingId);
		} else if (page === 2 && projectId) {
			setTypeId(projectId);
		}
		addPOI.setFieldValue("attachments", []);
		addPOI.setFieldValue("attachmentsToDelete", []);
		setPoiAttachments([]); // if you keep local state

		// ✅ reset back AFTER logic runs
		setBack(false);
	}, [back, page, projectId, buildingId, typeId]);

	const navigate = useNavigate();
	return (
		<div className="setup-header">
			{(page === 3 || page === 4) && (
				<div className="setup-header-tool" onClick={handleBackClick}>
					<img
						src={`${process.env.PUBLIC_URL}/assets/New/Randoms/arrow-left-round.svg`}
						alt="back"
					/>
				</div>
			)}

			<div>{trans(`${type} Details`)}</div>
			<div
				className="setup-header-tool"
				onClick={() => navigate("/setup/project-setup")}
			>
				<img src={`${process.env.PUBLIC_URL}/assets/Close.svg`} alt="back" />
			</div>
		</div>
	);
}
